import { createSelector } from '@reduxjs/toolkit';
import { handleActions } from 'redux-actions';
import { DRIVER_LOG_MODULE, FILTER_TEMPLATE_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin, createLoadParameterReducer, createOperationStateReducer, updateLoadParameterReducer,
} from '../../utils/getCrudConfig';
import {
  CREATE_FILTER_TEMPLATE,
  LOAD_FILTER_TEMPLATE_BY_ID,
  LOAD_FILTER_TEMPLATE_LIST,
  UPDATE_FILTER_TEMPLATE,
} from './actions';

const initialState = {
  filterTemplateList: [],
  filterTemplateListMeta: {},
  loadingFilterTemplateList: false,
  loadingFilterTemplate: false,
  filterTemplate: {},
  loadingCreateFilterTemplate: false,
  loadingUpdateFilterTemplate: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_LIST, 'filterTemplateList', 'loadingFilterTemplateList'),
  ...updateLoadParameterReducer(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_BY_ID, 'filterTemplate', 'loadingFilterTemplate'),
  ...createOperationStateReducer(FILTER_TEMPLATE_MODULE + CREATE_FILTER_TEMPLATE, 'loadingCreateFilterTemplate'),
  ...createOperationStateReducer(FILTER_TEMPLATE_MODULE + UPDATE_FILTER_TEMPLATE, 'loadingUpdateFilterTemplate'),
}, initialState);

export default reducer;

export const getFilterTemplateData = createSelector(
  [state => state[FILTER_TEMPLATE_MODULE]],
  state => {
    const {
      filterTemplateList,
      filterTemplateListMeta,
      loadingFilterTemplateList,
      loadingFilterTemplate,
      filterTemplate,
      loadingCreateFilterTemplate,
      loadingUpdateFilterTemplate,
    } = state;

    return {
      filterTemplateList,
      filterTemplateListMeta,
      loadingFilterTemplateList,
      loadingFilterTemplate,
      filterTemplate,
      loadingCreateFilterTemplate,
      loadingUpdateFilterTemplate,
    };
  },
);
